import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";

const WvAlert: HTMLComponent<{ type: "danger" | "warning" | "success" }> = ({
  children,
  type,
  className,
  ...props
}) => {
  return (
    <div
      className={classNames(
        "mb-5 px-5 py-2.5 text-center text-sm",
        {
          "bg-alert-danger text-white": type === "danger",
          "bg-alert-warning text-white": type === "warning",
          "bg-alert-success text-white": type === "success",
        },
        className
      )}
      role="alert"
      {...props}
    >
      {children}
    </div>
  );
};

export default WvAlert;
